import styled, { css } from 'styled-components';

import { StyledSpacingProps, spacingStyles } from '../../styles';
import { boxShadows, colors } from '../../theme';
import { CardRoot } from '../Card/Card.styled';
import { CardSpacingKey } from '../Card/constants';

const clickStyles = css(
  ({ theme }) => `
  cursor: pointer;
  outline: none;

  &:hover {
    box-shadow: ${boxShadows.elevation3};
  }

  &:focus-visible {
    box-shadow: 0 0 0 4px ${theme.core.color.neutral[600]};
  }

 &[aria-disabled="true"] {
  pointer-events: none;
  background-color: ${colors.pearl};
}
`,
);

export const ClientCardRoot = styled(CardRoot)<StyledSpacingProps>`
  justify-content: space-between;
  width: 100%;
  max-width: 640px;
  padding: ${({ theme }) => theme.core.spacing[CardSpacingKey]};
  box-shadow: ${boxShadows.elevation1};

  ${({ onClick }) => (onClick ? clickStyles : '')}

  ${spacingStyles}
`;
